<template>
  <div class="container">
    <div class="login" id="login">
      <div class="loading" v-if="performingRequest">
        <p>Loading...</p>
      </div>
      <div>
        <h1>Welcome to Cereal City Science Online</h1>
      </div>

        <!-- *****     LOGIN     ***** -->

        <div class="login-form" v-if="showLoginForm">
          <h3>Log Into Cereal City Science Online</h3>
          <label for="email1"></label>
          <input type="text" id="email1" v-model.trim="loginForm.email" placeholder="Email">
          <br/>
          <label for="password1"></label>
          <input type="password" id="password1" v-model.trim="loginForm.password" placeholder="Password">
          <br/>
          <button class="button" @click.prevent="login">Log In</button>
          <div class="extras">
            <a @click="togglePasswordReset">Forgot Password?</a>
          </div>
          <p class="decorated"><span>or</span></p>
          <a href="/create-account" class="create-button" v-if="create">Create Account</a>
          <p v-if="!create">Loading...</p>
        </div>

        <!-- *****     PASSWORD RESET     ***** -->

        <div class="login-form" v-if="showForgotPassword">
          <h3 style="border-bottom: 1px solid #cecece; padding-bottom: 15px;">Password Reset</h3>
          <p style="text-align: left;">Please enter the email address you used to setup your account. If the account exists, you will receive an email with a link to reset your password.</p>
          <label for="email2"></label>
          <input type="text" id="email2" v-model.trim="passwordForm.email" placeholder="Email">
          <br />
          <button class="button" @click.prevent="resetPassword">Request Password Reset</button>
          <div class="cancel-button">
            <a @click="toggleLoginPage">Cancel</a>
          </div>
        </div>

        <!-- *****     RESET SUCCESS     ***** -->

        <div  class="login-form" v-if="passwordResetSuccess">
          <h3 style="border-bottom: 1px solid #cecece; padding-bottom: 15px;">Request Sent</h3>
          <p style="text-align: left;">Please check your email for a link to reset your password.</p>
          <button @click.prevent="toggleLoginPage">Return to Login</button>
        </div>

      <div class="error-msg" v-if="errorMsg">
        <p>{{ errorMsg }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const fb = require('./../firebase/firebase.js')

export default {
  data() {
    return {
      loginForm: {
        email: '',
        password: ''
      },
      passwordForm: {
        email: ''
      },
      showLoginForm: true,
      showForgotPassword: false,
      passwordResetSuccess: false,
      performingRequest: false,
      errorMsg: '',
      create: false
    }
  },
  computed: {
    ...mapState([ 'userProfile', 'currentUser' ])
  },
  methods: {
    toggleForm() {
      this.errorMsg = ''
      this.showLoginForm = !this.showLoginForm
    },
    toggleLoginPage() {
      this.errorMsg = null
      this.showForgotPassword = false
      this.passwordResetSuccess = false
      this.showLoginForm = true
    },
    togglePasswordReset() {
      if (this.showForgotPassword) {
        this.showLoginForm = true
        this.showForgotPassword = false
        this.passwordResetSuccess = false
      } else {
        this.showLoginForm = false
        this.showForgotPassword = true
      }
    },
    login() {
      this.performingRequest = true

      fb.auth.signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password).then(user => {
        this.$store.commit('SET_CURRENT_USER', user.user)
        this.$store.dispatch('fetchUserProfile')
      }).then(() => {
        setTimeout(() => {
          this.$store.commit('SET_DASHBOARD_VIEW', 'units')
          this.performingRequest = false
          // if (this.userProfile.role == 'admin') {
          //   this.$router.push('/admin')
          // } else {
          //   this.$router.push('/dashboard')
          // }
          // this.$router.push(this.$route.query.redirect || '/dashboard')
          this.$router.push(sessionStorage.getItem('redirectPath') || '/dashboard')
          sessionStorage.removeItem('redirectPath')
        }, 1500)
      }).catch(err => {
        console.log(err)
        this.performingRequest = false
        this.errorMsg = err.message
      })
    },
    resetPassword() {
      this.performingRequest = true

      fb.auth.sendPasswordResetEmail(this.passwordForm.email).then(() => {
        this.performingRequest = false
        this.passwordResetSuccess = true
        this.passwordForm.email = ''
        this.showLoginForm = false
        this.showForgotPassword = false
      }).catch(err => {
        console.log(err)
        this.performingRequest = false
        this.errorMsg = err.message
      })
    }
  },
  mounted() {
    if (this.currentUser) {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
      this.$router.push('/dashboard')
    } else {
      setTimeout(() => {
        console.log('no user')
        this.create = true
      }, 3000)
    }
  }
}
</script>

<style lang="css" scoped>
h1 {
  margin-bottom: 30px;
}
h3 {
  margin-bottom: 20px;
  font-size: 1em;
}
.login-form {
  display: table;
  max-width: 380px;
  background-color: #f7f7f7;
  border: 1px solid #cecece;
  border-radius: 7px;
  margin: auto;
  padding: 30px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
input {
  border: 1px solid #cecece;
  border-radius: 5px;
  background-color: white !important;
  height: 40px;
  width: 300px;
  padding: 10px;
  margin: 5px;
}
button {
  height: 40px;
  width: 300px;
  margin: 5px auto;
  color: white;
  background-color: #f47e20;
  border: none;
  border-radius: 5px;
  font-size: 1.2em;
  font-weight: 600;
  cursor: pointer;
}
hr {
  margin-bottom: 30px;
}
.create-button {
  background-color: #26577f;
  width: 200px;
  height: 45px;
  margin: 5px;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1.2em;
  font-weight: 600;
  cursor: pointer;
  padding: 10px 20px;
}
.extras {
  margin: 20px;
}
.cancel-button {
  margin-top: 15px;
  margin-bottom: 0;
}
.decorated{
     overflow: hidden;
     text-align: center;
     color: #777;
     font-size: .85em;
     font-weight: 600;
     margin-bottom: 30px;
 }
.decorated > span{
    position: relative;
    display: inline-block;
}
.decorated > span:before, .decorated > span:after{
    content: '';
    position: absolute;
    top: 50%;
    border-bottom: 1px solid #777;
    width: 100vw;
    margin: 0 10px;
}
.decorated > span:before{
    right: 100%;
}
.decorated > span:after{
    left: 100%;
}
</style>
